import React, { useState } from "react";
import Icon from "@icon-park/react/es/all";
import {
  Bar,
  InnerBar,
  PasswordIconWrapper,
  PasswordInputWrapper,
} from "./styled";
import GenericInput from "../GenericInput";
import { theme } from "../../styles";
import InputWrapper from "../InputWrapper";

type Props = {
  heading?: string;
  errorMessage?: string;
  onChange: (date: string) => void;
  value?: string;
  disabled?: boolean;
  name?: string;
  hideBar?: boolean;
  minNumCharacters?: number;
};

const PasswordInput: React.FC<Props> = ({
  heading,
  value,
  onChange,
  errorMessage,
  disabled,
  name,
  hideBar,
  minNumCharacters = 8,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [validation, setValidation] = useState<string | null>("");
  const error = validation || errorMessage || false;
  const isPasswordValid = Boolean(value && value.length >= minNumCharacters);

  const onBlurAction = () => {
    setValidation(errorMessage || "");
  };

  const toggleVisibility = () => setShowPassword(!showPassword);

  return (
    <InputWrapper heading={heading} errorMessage={errorMessage}>
      <PasswordInputWrapper>
        <GenericInput
          withIcon
          data-testid="password-input"
          onBlur={onBlurAction}
          type={showPassword ? "text" : "password"}
          placeholder="••••••••••"
          onChange={(e) => onChange(e.target.value)}
          value={value}
          disabled={disabled}
          focused={isFocused}
          name={name}
          hasError={!!error}
          onFocus={() => setIsFocused(true)}
        />
        <PasswordIconWrapper>
          <Icon
            type={showPassword ? "PreviewCloseOne" : "PreviewOpen"}
            size={24}
            onClick={toggleVisibility}
            fill={theme.colors.SLATE500}
            data-testid="password-input-show-password-toggle"
          />
        </PasswordIconWrapper>
      </PasswordInputWrapper>
      {!hideBar && (
        <Bar>
          <InnerBar hasError={!!error} isValid={isPasswordValid} />
        </Bar>
      )}
    </InputWrapper>
  );
};

export default PasswordInput;
